import { TranslationService } from '../../../services/translation.service';

const translationClearFilters = TranslationService.get('common.clear');

function ClearButtonComponent({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className="btn btn-tertiary btn-icon-left btn-icon-rotate-left" onClick={onClick}>
      {translationClearFilters}
    </button>
  );
}

export default ClearButtonComponent;
